/* NW Wellness — Cart page + drawer
   Quantity updates via /cart/change.js, remove via /cart/change.js with qty=0,
   drawer open/close + backdrop, Esc-to-close. */

(function () {
  const root = window.Shopify?.routes?.root || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return '£' + (Number(cents) / 100).toFixed(2);
  }

  async function updateLine(key, quantity) {
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  }

  function refreshSubtotal(cart) {
    const sub = $('[data-nw-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function bindLine(li) {
    const key = li.dataset.lineKey;
    const input = $('[data-nw-qty-input]', li);
    const dec = $('[data-nw-qty-dec]', li);
    const inc = $('[data-nw-qty-inc]', li);
    const removeBtn = $('[data-nw-line-remove]', li);

    const controls = [dec, inc, input, removeBtn].filter(Boolean);
    let busy = false;

    async function change(qty) {
      if (busy) return;
      busy = true;
      controls.forEach((el) => { el.disabled = true; });
      li.classList.add('nw-line--loading');
      try {
        const cart = await updateLine(key, qty);
        if (qty === 0) li.remove();
        else input.value = qty;
        refreshSubtotal(cart);
        if (cart.item_count === 0) window.location.reload();
      } catch (e) { /* swallow */ }
      busy = false;
      li.classList.remove('nw-line--loading');
      controls.forEach((el) => { el.disabled = false; });
    }

    if (dec) dec.addEventListener('click', () => change(Math.max(0, Number(input.value) - 1)));
    if (inc) inc.addEventListener('click', () => change(Number(input.value) + 1));
    if (input) input.addEventListener('change', () => change(Math.max(0, Number(input.value))));
    if (removeBtn) removeBtn.addEventListener('click', () => change(0));
  }

  $$('.nw-line').forEach(bindLine);

  /* ---------- Drawer ---------- */
  class NWCartDrawer extends HTMLElement {
    connectedCallback() {
      this.backdrop = $('[data-nw-drawer-backdrop]');

      this.openHandler = () => this.open();
      this.refreshHandler = () => this.refresh();
      this.keyHandler = (e) => { if (e.key === 'Escape' && this.hasAttribute('data-open')) this.close(); };
      this.backdropHandler = () => this.close();
      // Delegate the close-button click on `this` so it survives
      // innerHTML replacement during refresh().
      this.delegatedClick = (e) => {
        if (e.target.closest('[data-nw-drawer-close]')) this.close();
      };

      document.addEventListener('cart:open', this.openHandler);
      document.addEventListener('cart:updated', this.refreshHandler);
      document.addEventListener('keydown', this.keyHandler);
      this.addEventListener('click', this.delegatedClick);
      if (this.backdrop) this.backdrop.addEventListener('click', this.backdropHandler);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:open', this.openHandler);
      document.removeEventListener('cart:updated', this.refreshHandler);
      document.removeEventListener('keydown', this.keyHandler);
      if (this.backdrop) this.backdrop.removeEventListener('click', this.backdropHandler);
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => {
        this.setAttribute('data-open', '');
        if (this.backdrop) this.backdrop.setAttribute('data-open', '');
        document.body.classList.add('nw-drawer-open');
      });
      this.refresh();
    }
    close() {
      this.removeAttribute('data-open');
      if (this.backdrop) this.backdrop.removeAttribute('data-open');
      document.body.classList.remove('nw-drawer-open');
      setTimeout(() => { this.hidden = true; }, 300);
    }

    async refresh() {
      try {
        const res = await fetch(root + '?section_id=nw-cart-drawer', { headers: { Accept: 'text/html' } });
        if (!res.ok) return;
        const html = await res.text();
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        const fresh = wrap.querySelector('nw-cart-drawer');
        if (fresh) this.innerHTML = fresh.innerHTML;
        // Re-bind newly inserted lines
        $$('.nw-line', this).forEach(bindLine);
      } catch (e) { /* swallow */ }
    }
  }

  if (!customElements.get('nw-cart-drawer')) {
    customElements.define('nw-cart-drawer', NWCartDrawer);
  }

  /* Open the drawer when header cart link is clicked (and prevent navigation) */
  document.addEventListener('click', (e) => {
    const cart = e.target.closest('.nw-header__cart');
    if (!cart) return;
    if (!document.querySelector('nw-cart-drawer')) return; // drawer not present, follow link
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('cart:open'));
  });

  /* Open drawer after add-to-cart */
  document.addEventListener('cart:updated', () => {
    if (document.querySelector('nw-cart-drawer')) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  });
})();
